import Vue from 'vue';

Vue.component('sales-movement-index-es', () =>
    import(/* webpackChunkName: 'sales-movement-index-es' */ './es-report/sales-movement-index-es.vue'),
);



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/report/sales-movement/index.js